<pr-status-label
  [dense]="dense()"
  [color]="statusColor()"
  [label]="statusLabel()"
/>
